import { hasVisibleProposalTarget } from '@features/proposals/proposals-overview-bar-layout.helpers';

type ReportSummaryBarDiffOptions = {
  /** When true, the caller omits the delta. The summary chart leaves this unset. */
  isBaseline?: boolean;
  target: number | null | undefined;
  co2ePerGfa: number;
};

/**
 * CO₂ target drawn on the summary. Zero stays stored but is not shown.
 */
export const getReportSummaryVisibleTarget = (
  target: number | null | undefined,
): number | undefined =>
  hasVisibleProposalTarget(target) ? target : undefined;

/**
 * Height of the summary target line, as a percent of the bar plot.
 * Absent when the target is hidden or the scale has no height.
 */
export const getReportSummaryTargetLineBottomPercent = (
  visibleTarget: number | undefined,
  maxCo2e: number,
): number | null => {
  if (visibleTarget === undefined || maxCo2e <= 0) return null;
  return (visibleTarget / maxCo2e) * 100;
};

/**
 * Signed CO₂e/m² delta shown above a proposal bar.
 * Absent when the target is missing or zero.
 * Pass {@link ReportSummaryBarDiffOptions.isBaseline} to omit the delta, as the product-groups fallback does.
 * The report and Build both draw this inside the red or green plate.
 */
export const getReportSummaryBarDiffValue = ({
  isBaseline = false,
  target,
  co2ePerGfa,
}: ReportSummaryBarDiffOptions): number | undefined => {
  if (isBaseline) return undefined;
  if (!hasVisibleProposalTarget(target)) return undefined;
  return co2ePerGfa - target;
};
